<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none" viewBox="0 0 10 2">
        <path
            fill="#fff"
            fill-rule="evenodd"
            d="M0 1c0-.552285.471279-1 1.05263-1h7.89474C9.52872 0 10 .447715 10 1c0 .55228-.47128 1-1.05263 1H1.05263C.471279 2 0 1.55228 0 1"
            clip-rule="evenodd"
        />
    </svg>
</template>
